import { Component, OnChanges, ViewEncapsulation, ElementRef, ViewChild, Input,
  SimpleChanges } from '@angular/core';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VideoPlayerComponent implements OnChanges {
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  @Input() videoSrc: string = '';
  @Input() videoStamp: string = '';
  @Input() videoStampTag: string = '';
  @ViewChild('video') public video: ElementRef;
  // @ViewChild('videoContainer') public videoContainer: ElementRef;

  constructor() { }

  ngOnInit() {
    console.log('video src: ', this.videoSrc);
    // Subscribe to onresize
    // this.resizeObservable$ = fromEvent(window, 'resize');
    // this.resizeSubscription$ = this.resizeObservable$.subscribe( evt => {
    //   console.log('event in player: ', evt);
    //   const w = this.videoContainer.nativeElement.offsetWidth;
    //   const h = this.videoContainer.nativeElement.offsetHeight;
    //   console.log('height of player container: ', w, h);

    //   // const _vidWidth = 600;
    //   // const _vidHeight = 345;
    //   // const _ratio = _vidWidth/_vidHeight;
    //   // const newHeight = _width / _ratio;


    //   // var w = window.innerWidth;
    //   // var h = window.innerHeight;
    //   //console.log(w);
    //   //console.log(h);

    //   let img = this.video.nativeElement;
    //   const ratio = (img.clientHeight / img.clientWidth);
    //   if (img.clientHeight > h && img.clientWidth < w) {
    //       img.style.height = h + "px";
    //       img.style.width = (h / ratio) + "px";
    //   }
    //   if (img.clientHeight <= h && img.clientWidth < w && ratio > 1) {
    //       img.style.height = h + "px";
    //       img.style.width = (h / ratio) + "px";
    //   }
    //   if (img.clientWidth >= w) {
    //       img.style.width = w + "px";
    //   }
    //   if (img.clientHeight < h && img.clientWidth <= w  && ratio < 1) {
    //       img.style.width = w + "px";
    //   }
  
    //  // this.video.nativeElement.style.height = newHeight + 'px';



    // });

  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log('video src changed', this.videoSrc);
    if (changes.videoSrc) {
      const player = this.video.nativeElement;
      player.load();
      // player.play();
    }
  }
  // TODO
  // playVideo(url: string) {
  //   this.video.nativeElement.src = url;
  //   this.video.nativeElement.load();
  //   this.video.nativeElement.play();
  // }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/video-player/video-player.component.ts